import { SEMANTIC_SEARCH_ACTION_NAMES } from './semantic-search-action-types';

export const setUseSemanticSearchT = (entityType, id, value) => ({
  type: SEMANTIC_SEARCH_ACTION_NAMES[entityType.toUpperCase()]['SET_USE_SEMANTIC_SEARCH'],
  id,
  value,
});
